import React, { useEffect, useState } from "react";
import "./styles.css";
import logo from "../../utils/images/zostelLogo.svg";

const UnAuthModal = ({ logout }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setVisible(true);
        }, 100);
        setTimeout(() => {
            logout();
        }, 2000);
    }, [logout]);

    return (
        <section id="unauth-modal">
            <div id="unauth-form" className={visible ? "visible" : ""}>
                <img src={logo} alt="" />
                <h1>You are not authorized to use Zo Supply.</h1>
            </div>
        </section>
    );
};

export default UnAuthModal;
